export const missingFamilyGroup = (rowdata: string) => {
    if(rowdata !== undefined &&rowdata !== null   )
    {
  
      let value= rowdata.trim() as string;
        if(value=== "null" || value === "" || value === 'undefined')
        {
           return true
        }
        else
        {
          return false
        }
   }
   else if(rowdata === null)
    {
      return true
    }
    else
    {
    return false
    }
  
  }
  